import moment from 'moment';

export const checkIsAfter = (first: string | Date, second?: string | Date): boolean => moment(first).isAfter(second);
